import showdown from "showdown";


export const markdownToHtml = (markdown) => {
  const converter = new showdown.Converter({
    smartIndentationFix: true,
    tables: true,
  });
  return converter.makeHtml(markdown);
};

function emailType(tabname, officeType) {
  if (tabname == "reply") {
    return "Reply";
  } else if (tabname == "replyall") {
    return "Reply All";
  } else if (tabname == "forward") {
    return "Forward";
  } else if (tabname == "new" && officeType == "OUTLOOK") {
    return "New Email";
  } else if (tabname == "new" && officeType == "WORD") {
    return "New Document Part";
  }
  return "";
}

export const formatUserMessage = (message, tabname, officeType = "OUTLOOK") => {
  if (tabname == "chat") {
    return message;
  } else {
    var userMessage = `Draft ${emailType(tabname, officeType)}`;

    if (message.trim() !== "") {
      userMessage += ` with the following instructions: ${message}`;
    }
    userMessage += ".";
    return userMessage;
  }
};

export const htmlToText = (html) => {
  // Replace <br> with newline
  html = html.replace(/<br\s*\/?>/gi, "\n");
  // Replace <p> and <div> with double newline
  html = html.replace(/<\/p>/gi, "\n");
  html = html.replace(/<\/div>/gi, "\n");
  // Remove all other tags
  html = html.replace(/<[^>]+>/g, "");
  // Replace &nbsp; with newline
  html = html.replace(/&nbsp;/g, "\n");
  // Trim leading and trailing whitespace
  return html.trim();
};
